export default __webpack_public_path__ + "static/hq2-ae88815bb461c8b1099c42e383f8c9e3.jpg";